import axios from 'axios'
import { auth } from '@/plugins/auth'
import settings from '../../../public/settings.json'

const API_WS_PATH = settings.wsPath

export async function uploadFile(file) {
  const token = await auth.getToken()

  const formData = new FormData()
  formData.append('file', file)
  const response = await axios.post(API_WS_PATH + 'AddFile.ashx', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}